export class Main {
  static root = '/api/v1'

  static getRoot() {
    return this.root
  }
}
